import { FlagUrlPipe } from 'src/app/pipes/flag-url/flag-url.pipe';
import { Component, OnDestroy, OnInit } from '@angular/core'
import { IonButton } from '@ionic/angular/standalone'
import { Subscription } from 'rxjs'
import { PermissionType } from 'src/app/constants/global.const'
import { GlobalService } from 'src/app/services/global/global.service'
import { NavigationService } from 'src/app/services/navigation/navigation.service'
import { StorageService } from 'src/app/services/storage/storage.service'
import { Profile } from 'src/app/types/rest.types'

@Component({
  selector: 'app-template-lock',
  templateUrl: './template-lock.component.html',
  styleUrls: ['./template-lock.component.scss'],
  imports: [FlagUrlPipe, IonButton],
})
export class TemplateLockComponent implements OnInit, OnDestroy {
  profile?: Profile
  profile$?: Subscription

  PermissionType = PermissionType

  constructor(
    public global: GlobalService,
    private navigation: NavigationService,
    private storage: StorageService,
  ) {}

  ngOnInit() {
    this.__subscribe()
  }

  ngOnDestroy() {
    this.__unsubscribe()
  }

  toPaymentCashPage() {
    this.global.hideLockDialog()
    this.navigation.toPaymentCashListingPage()
  }

  private __subscribe() {
    this.profile$ = this.storage.profile$.subscribe((profile) => {
      this.profile = profile
    })
  }

  private __unsubscribe() {
    this.profile$?.unsubscribe()
    this.profile$ = undefined
  }
}
